import { SET_SITE_INFO } from '../actions/types';

export default function siteInfo(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_SITE_INFO:
				return action.payload;

			// no default
		}
	}

	return state;
}
